var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v("ログインでお困りの場合はこちら")])}
var staticRenderFns = []

export { render, staticRenderFns }